import Reveal from "@/components/escape21/Reveal";
import { STATIC_PRINTS } from "./constants";

const StaticPosts = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-6xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          posts estáticos
        </span>
        <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          o feed também <span className="e21-serif text-green-400">estoura</span>.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/55 sm:text-lg">
          post parado não é post fraco. tem foto batendo 200 mil views e 130 mil
          contas alcançadas.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-5">
        {STATIC_PRINTS.map((src, i) => (
          <Reveal key={src} delay={(i % 5) * 60}>
            <img
              src={src}
              alt={`insight de post estático ${i + 1}`}
              loading="lazy"
              className="w-full rounded-xl border border-white/10 bg-white/5 transition-transform duration-300 hover:scale-[1.03]"
            />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default StaticPosts;
